import React, {PropsWithChildren} from "react";
import {Box, useRadio, UseRadioProps} from "@chakra-ui/react";

const RadioCard: React.FC<PropsWithChildren<UseRadioProps>> = (props) => {
  const {getInputProps, getRadioProps} = useRadio(props)

  const input = getInputProps()
  const checkbox = getRadioProps()

  return (
    <Box as='label'>
      <input {...input} />
      <Box
        {...checkbox}
        cursor='pointer'
        borderWidth='1px'
        borderRadius='md'
        boxShadow='md'
        bg="loginInputsBackground.500"
        color="white"
        px={4}
        py={2}
        _checked={{
          bg: 'brandPurple.500',
          color: 'white',
          borderColor: 'violetPurple.500',
        }}
        _focus={{
          boxShadow: '0 0 0 2px brandPurple.500',
        }}
        _hover={{borderColor: "brandPurple.400"}}
      >
        {props.children}
      </Box>
    </Box>
  )
}

export default RadioCard;